import React from 'react';
import DailyCheckInHeader from './DailyCheckInHeader';
import DailyCheckInRow from './DailyCheckInRow';

export default function DailyCheckInTable({
  loading,
  reportData,
  page,
  limit,
  setPage,
  actions,
  filters,
  setFilters,
}) {
  const renderRows = () => {
    if (loading) {
      return (
        <tr>
          <td colSpan={8} className="text-center py-4">
            <i className="fa fa-spinner fa-spin" />
          </td>
        </tr>
      );
    }

    if (!reportData || reportData.users.length === 0) {
      return (
        <tr>
          <td colSpan={8} className="text-center py-4">
            No users found.
          </td>
        </tr>
      );
    }

    return reportData.users.map((user) => (
      <DailyCheckInRow key={user.userId} user={user} actions={actions} />
    ));
  };

  const renderPagination = () => {
    if (!reportData) return null;

    const totalPages = Math.ceil(reportData.total / limit);

    return (
      <div className="pagination-controls mt-3">
        <button
          disabled={page <= 1}
          onClick={() => setPage(page - 1)}
          className="pagination-btn"
        >
          Prev
        </button>

        <span className="mx-2">
          Page {page} of {totalPages}
        </span>

        <button
          disabled={page >= totalPages}
          onClick={() => setPage(page + 1)}
          className="pagination-btn"
        >
          Next
        </button>
      </div>
    );
  };

  return (
    <div className="daily-checkin-table mt-3">
      <table>
        <thead>
          <DailyCheckInHeader
            filters={filters}
            setFilters={setFilters}
            setPage={setPage}
            actions={actions}
          />
        </thead>

        <tbody>{renderRows()}</tbody>
      </table>

      {renderPagination()}
    </div>
  );
}
